export default {
    "incomeGoal": 125.0,
    "retirementStartAge": 65,
    "retirementEndAge": 95,
    "socialSecurityStartAge": 70,
    "incomeGoalUnit": "PCT",
    "participantProfile": {
        "firstName": "XRMGBV",
        "lastName": "LHEPBCDPVN",
        "gender": null,
        "bpId": 277,
        "rpsiid": "586cf53f-398f-4f10-b1b1-b4bc727113e7",
        "birthDate": "1988-10-12T00:00:00.000+00:00"
    },
    "scenarioId": 315085,
    "scenarioName": null,
    "scenarioType": "PRM",
    "spouseInclude": "Y",
    "overrideRetirementStartAge": true,
    "spouseRetirementStartAge": 65,
    "spouseRetirementEndAge": 95,
    "socialSecurityAmount": null,
    "spouseSocialSecurityStartAge": 70,
    "spouseSocialSecurityAmount": null,
    "spouseProfile": null,
    "accounts": [
        {
            "id": null,
            "bpId": 277,
            "name": "HUBBELL AE JOIN EMP(805222) SAVINGS AND INVESTMENT PLAN ",
            "asOfDate": "2023-07-20T04:00:00.000+00:00",
            "balance": 0.0,
            "accountCategory": "RPSAccountSummary",
            "displayAccountCategory": "RPSAccountSummary",
            "displayGroup": "T. Rowe Price Retirement Accounts",
            "includeInScenario": true,
            "overrideAccountTypeCode": null,
            "clientNumber": "800342",
            "planNumber": "805222",
            "retailTypeCategory": null,
            "type": "1",
            "displayType": "401K                                    ",
            "yodleeAgreementId": null,
            "idmAgreementId": null,
            "yodleeInstitutionId": null,
            "action": null,
            "status": "ACTIVE",
            "contribution": [
                {
                    "id": "A",
                    "sourceName": "PRETAX",
                    "amount": null,
                    "unit": "PCT",
                    "frequency": null,
                    "maxAmountPercent": 0.5,
                    "maxAmountDollar": null,
                    "inputType": " "
                },
                {
                    "id": "G",
                    "sourceName": "AFTER TAX",
                    "amount": null,
                    "unit": "PCT",
                    "frequency": null,
                    "maxAmountPercent": 0.4,
                    "maxAmountDollar": null,
                    "inputType": " "
                },
                {
                    "id": "S",
                    "sourceName": "ROTH",
                    "amount": null,
                    "unit": "PCT",
                    "frequency": null,
                    "maxAmountPercent": 0.5,
                    "maxAmountDollar": null,
                    "inputType": " "
                }
            ],
            "planMaxAmountDollar": null,
            "planMaxAmountPercent": 1.0,
            "planMaxCatchUpAmountDollar": null,
            "assetAllocation": null,
            "onlineContribEligible": true,
            "hsaRecordKeeperId": null,
            "hsaPlanSponsorId": null,
            "century": null,
            "includeOnly": true
        }
    ],
    "events": null,
    "compensations": [
        {
            "id": 302456,
            "bpId": 277,
            "clientNumber": "800342",
            "compensationType": "ASLRY",
            "payFrequency": "MLY",
            "amount": 25000.0,
            "action": null,
            "source": "userEntered",
            "tracPlanNumber": null,
            "sponsorProvidedPayFreq": false
        }
    ]
}
